/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const CreditCardR = t.interface({});

// optional attributes
const CreditCardO = t.partial({
  brand: t.string,

  brandLogo: t.string,

  expireMonth: t.string,

  expireYear: t.string,

  flag3dsVerified: t.boolean,

  holder: t.string,

  hpan: t.string,

  id: t.Integer,

  onUs: t.boolean,

  pan: t.string,

  securityCode: t.string
});

export const CreditCard = t.intersection(
  [CreditCardR, CreditCardO],
  "CreditCard"
);

export type CreditCard = t.TypeOf<typeof CreditCard>;
